/* eslint-disable */
import { v4 as uuidV4 } from 'uuid';
export class Convenio {
  constructor () {
    this.convenio_id = uuidV4()
    this.titulo = ''
    this.texto = ''
    this.imagens = []
  }
}
